<template><div><h2 id="baseline" tabindex="-1" class="d-docsite--header-2">Baseline <a class="header-anchor d-link d-docsite--link d-link" href="#baseline" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-va-baseline</code> to vertically align an element to the baseline.</p>
<code-example source-code='&lt;div class=&quot;d-w100p d-ps-relative d-lh0 d-bgc-moderate&quot;&gt;
  &lt;div class=&quot;d-w-0 d-h-25 d-d-inline-block d-va-baseline&quot;&gt;
    &lt;span class=&quot;d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus&quot;&gt;&lt;/span&gt;
    &lt;span class=&quot;d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus&quot;&gt;&lt;/span&gt;
  &lt;/div&gt;
  &lt;p class=&quot;d-fs-200 d-d-inline-block d-ps-relative d-zi-base1&quot;&gt;The quick brown fox.&lt;/p&gt;
&lt;/div&gt;'>
<div class="d-w100p d-ps-relative d-lh0 d-bgc-moderate">
  <div class="d-w-0 d-h-25 d-d-inline-block d-va-baseline">
    <span class="d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus"></span>
    <span class="d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus"></span>
  </div>
  <p class="d-fs-200 d-d-inline-block d-ps-relative d-zi-base1">The quick brown fox.</p>
</div>
</code-example>
<h2 id="top" tabindex="-1" class="d-docsite--header-2">Top <a class="header-anchor d-link d-docsite--link d-link" href="#top" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-va-top</code> to vertically align an element to the top.</p>
<code-example source-code='&lt;div class=&quot;d-w100p d-ps-relative d-lh0 d-bgc-moderate&quot;&gt;
  &lt;div class=&quot;d-w-0 d-h-25 d-d-inline-block d-va-top&quot;&gt;
    &lt;span class=&quot;d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus&quot;&gt;&lt;/span&gt;
    &lt;span class=&quot;d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus&quot;&gt;&lt;/span&gt;
  &lt;/div&gt;
  &lt;p class=&quot;d-fs-200 d-d-inline-block d-ps-relative d-zi-base1&quot;&gt;The quick brown fox.&lt;/p&gt;
&lt;/div&gt;'>
<div class="d-w100p d-ps-relative d-lh0 d-bgc-moderate">
  <div class="d-w-0 d-h-25 d-d-inline-block d-va-top">
    <span class="d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus"></span>
    <span class="d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus"></span>
  </div>
  <p class="d-fs-200 d-d-inline-block d-ps-relative d-zi-base1">The quick brown fox.</p>
</div>
</code-example>
<h2 id="middle" tabindex="-1" class="d-docsite--header-2">Middle <a class="header-anchor d-link d-docsite--link d-link" href="#middle" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-va-middle</code> to vertically align an element to middle.</p>
<code-example source-code='&lt;div class=&quot;d-w100p d-ps-relative d-lh0 d-bgc-moderate&quot;&gt;
  &lt;div class=&quot;d-w-0 d-h-25 d-d-inline-block d-va-middle&quot;&gt;
    &lt;span class=&quot;d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus&quot;&gt;&lt;/span&gt;
    &lt;span class=&quot;d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus&quot;&gt;&lt;/span&gt;
  &lt;/div&gt;
  &lt;p class=&quot;d-fs-200 d-d-inline-block d-ps-relative d-zi-base1&quot;&gt;The quick brown fox.&lt;/p&gt;
&lt;/div&gt;'>
<div class="d-w100p d-ps-relative d-lh0 d-bgc-moderate">
  <div class="d-w-0 d-h-25 d-d-inline-block d-va-middle">
    <span class="d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus"></span>
    <span class="d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus"></span>
  </div>
  <p class="d-fs-200 d-d-inline-block d-ps-relative d-zi-base1">The quick brown fox.</p>
</div>
</code-example>
<h2 id="bottom" tabindex="-1" class="d-docsite--header-2">Bottom <a class="header-anchor d-link d-docsite--link d-link" href="#bottom" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-va-bottom</code> to vertically align an element to the bottom.</p>
<code-example source-code='&lt;div class=&quot;d-w100p d-ps-relative d-lh0 d-bgc-moderate&quot;&gt;
  &lt;div class=&quot;d-w-0 d-h-25 d-d-inline-block d-va-bottom&quot;&gt;
    &lt;span class=&quot;d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus&quot;&gt;&lt;/span&gt;
    &lt;span class=&quot;d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus&quot;&gt;&lt;/span&gt;
  &lt;/div&gt;
  &lt;p class=&quot;d-fs-200 d-d-inline-block d-ps-relative d-zi-base1&quot;&gt;The quick brown fox.&lt;/p&gt;
&lt;/div&gt;'>
<div class="d-w100p d-ps-relative d-lh0 d-bgc-moderate">
  <div class="d-w-0 d-h-25 d-d-inline-block d-va-bottom">
    <span class="d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus"></span>
    <span class="d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus"></span>
  </div>
  <p class="d-fs-200 d-d-inline-block d-ps-relative d-zi-base1">The quick brown fox.</p>
</div>
</code-example>
<h2 id="text-top" tabindex="-1" class="d-docsite--header-2">Text Top <a class="header-anchor d-link d-docsite--link d-link" href="#text-top" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-va-text-top</code> to vertically align an element to text top.</p>
<code-example source-code='&lt;div class=&quot;d-w100p d-ps-relative d-lh0 d-bgc-moderate&quot;&gt;
  &lt;div class=&quot;d-w-0 d-h-25 d-d-inline-block d-va-text-top&quot;&gt;
    &lt;span class=&quot;d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus&quot;&gt;&lt;/span&gt;
    &lt;span class=&quot;d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus&quot;&gt;&lt;/span&gt;
  &lt;/div&gt;
  &lt;p class=&quot;d-fs-200 d-d-inline-block d-ps-relative d-zi-base1&quot;&gt;The quick brown fox.&lt;/p&gt;
&lt;/div&gt;'>
<div class="d-w100p d-ps-relative d-lh0 d-bgc-moderate">
  <div class="d-w-0 d-h-25 d-d-inline-block d-va-text-top">
    <span class="d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus"></span>
    <span class="d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus"></span>
  </div>
  <p class="d-fs-200 d-d-inline-block d-ps-relative d-zi-base1">The quick brown fox.</p>
</div>
</code-example>
<h2 id="text-bottom" tabindex="-1" class="d-docsite--header-2">Text Bottom <a class="header-anchor d-link d-docsite--link d-link" href="#text-bottom" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-va-text-bottom</code> to vertically align an element to text bottom.</p>
<code-example source-code='&lt;div class=&quot;d-w100p d-ps-relative d-lh0 d-bgc-moderate&quot;&gt;
  &lt;div class=&quot;d-w-0 d-h-25 d-d-inline-block d-va-text-bottom&quot;&gt;
    &lt;span class=&quot;d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus&quot;&gt;&lt;/span&gt;
    &lt;span class=&quot;d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus&quot;&gt;&lt;/span&gt;
  &lt;/div&gt;
  &lt;p class=&quot;d-fs-200 d-d-inline-block d-ps-relative d-zi-base1&quot;&gt;The quick brown fox.&lt;/p&gt;
&lt;/div&gt;'>
<div class="d-w100p d-ps-relative d-lh0 d-bgc-moderate">
  <div class="d-w-0 d-h-25 d-d-inline-block d-va-text-bottom">
    <span class="d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus"></span>
    <span class="d-ps-absolute d-ibs-0 d-h-25 d-w100p d-by d-bts-dashed d-bbs-dashed d-bc-focus"></span>
  </div>
  <p class="d-fs-200 d-d-inline-block d-ps-relative d-zi-base1">The quick brown fox.</p>
</div>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody>
      <tr v-for="i in ['baseline', 'top', 'bottom', 'text-top', 'text-bottom', 'middle', 'sub', 'super', 'unset']">
          <th scope="row" class="d-code--sm d-docsite-code">.d-va-{{ i }}</th>
          <td class="d-code--sm">vertical-align: {{ i }} !important;</td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


